import CarouselAbstr, {type CarouselOptions} from '../CarouselAbstr';
import Slide from '../Slide';

export default class FeatureCarousel extends CarouselAbstr {
	constructor(options: CarouselOptions) {
		super(options);
		this.init();
	}

	protected init(): void {
		const slidesColl = this.carouselEl.getElementsByClassName('featureCarousel__slide');

		for (let i = 0; i < slidesColl.length; i++) {
			const element = slidesColl[i];
			const isActive = i === 0;

			// Add active class to first slide
			if (isActive) {
				element.classList.add('active');
			}

			this.slides.push(new Slide({element, isActive}));
		}
		this.slides.forEach((slide, index) => {
			const indicators = this.buildIndicators(index);
			if (indicators) {
				slide.element.getElementsByClassName('featureCarousel__contentInner')[0]?.appendChild(indicators);
			}
		});
		this.initAutoAdvance();
	}
}
